import { Box } from '@chakra-ui/react';
import { FC } from 'react';

const SettingsDivider: FC = () => (
    <Box borderWidth={2} borderColor="gray.700" my={12} />
);

export default SettingsDivider;
